module.exports = __webpack_public_path__ + "img/moshushijoker_20210901113159.f077692d.png";